class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    // Call the function on page load
    
    // Listen for selling plan changes
    this.addEventListener('change', (event) => {
      if (event.target.matches('.cart-drawer-b-version__subscription-details-select')) {
        this.handleSellingPlanChange(event);
      }
    }); 

    // Listen for selling plan changes
    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"][name^="selling_plan_"]')) {
        this.handleSellingPlanChange(event);
      }
    });

    // Listen for selling plan changes
    this.addEventListener('change', (event) => {
      if (event.target.matches('.switch input[type="checkbox"]')) {
        this.handleCheckboxChange(event);
      }
    }); 
 
  }


 handleCheckboxChange(event) {
    const cartItemIndex = event.target.getAttribute('cart-item-index');
    const isChecked = event.target.checked;

    const subscriptionDetails = document.querySelector(
      `.cart-drawer-b-version__subscription-details select[data-index="${cartItemIndex}"]`
    )?.closest('.cart-drawer-b-version__subscription-details');

    if (!subscriptionDetails) return;

    const lineItem = document.querySelector(`#CartDrawer-Item-${cartItemIndex}, #CartItem-${cartItemIndex}`);
    const quantityInput = lineItem.querySelector('input[data-quantity-variant-id]');
   const quantityValue = quantityInput.value; 
    const variantId = quantityInput.getAttribute('data-quantity-variant-id');
    const subscriptionSelect = document.querySelector(`.cart-drawer-selector-${cartItemIndex}`);

    const sellingPlan = isChecked
      ? { sellingPlanId: subscriptionSelect.options[1]?.value || '' }
      : { sellingPlanId: '' };

    subscriptionDetails.style.display = isChecked && sellingPlan.sellingPlanId ? 'block' : 'none';
   
    this.updateSellingPlan(
      cartItemIndex,
      quantityValue,
      lineItem.querySelector('input[name="updates[]"]').name,
      variantId,
      sellingPlan
    );
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    // Fetch and update free shipping progress when the component is connected
    // this.fetchCartTotalAndUpdateProgress();
    this.attachEventListeners();
    
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }


  // Your existing code (inside attachEventListeners)
  attachEventListeners() 
  {
    
    let timerInput = document.querySelector('#timer_count');
    if(timerInput)
    {
      let timeLeft = timerInput ? parseFloat(timerInput.value) * 60 : 0; // Default to 0 if the element is not found
      let timerElement = document.querySelector('.timetext');
      timerElement = timerInput? document.querySelector('.timetext') : '';
  
      if (timerElement) {
        const countdown = setInterval(() => {
          let minutes = Math.floor(timeLeft / 60);
          let seconds = timeLeft % 60;
          timerElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          timeLeft--;
          if (timeLeft < 0) {
            clearInterval(countdown);
            timerElement.textContent = "Time's up!";
          }
        }, 1000);
      } 
      else {
        console.error("Element with class timetext not found.");
      }
  
      // Function to update the width of the progress bar
      function updateProgressBar(percentage) {
        const progressBars = document.querySelectorAll('.xbar');
        let percentagetext = '';
        progressBars.forEach(progressBar => {
          progressBar.style.width = percentage + '%';
          if (percentage == 66.66) {
            percentagetext = 20;
          } else if (percentage == 99.99) {
            percentagetext = 30;
          } else {
            percentagetext = 10;
          }
          progressBar.textContent = percentagetext + '%';
        });
      }
  
      let xcart_item_count = document.querySelector('.xcart_item_count').value;
      let xcart_item_count_progress = xcart_item_count;
      if (xcart_item_count == 2) {
        xcart_item_count = 1;
      } else {
        xcart_item_count = 2;
      }
      let selectedCount = 0;
      const selectedItems = [];
  
      document.querySelectorAll('.additem').forEach(button => {
        button.addEventListener('click', function() {
          if (selectedCount < xcart_item_count) {
            const item = this.closest('.xitems');
            const productName = item.querySelector('.pname').innerText;
            const variant = item.querySelector('.xvariant').value;
            const price = item.querySelector('.xprice').innerText;
            const imageSrc = item.querySelector('img').src;
            const subscribeDiscountPct = item.querySelector('.js-subscribe-discount-pct')?.value || null;
            const applyDiscount = item.querySelector('.apply_discount')?.value || null;
    
            selectedItems.push({
              productName: productName,
              variant: variant,
              price: price,
              imageSrc: imageSrc,
              quantity: 1,
              subscribeDiscountPct:subscribeDiscountPct,
              applyDiscount:applyDiscount,
            });
    
            if (selectedCount == 0 && xcart_item_count_progress == 1) {
              updateProgressBar(66.66);
            } else if (selectedCount == 0 && xcart_item_count_progress == 2) {
              updateProgressBar(99.99);
            } else if (selectedCount == 1 && xcart_item_count_progress == 1) {
              updateProgressBar(99.99);
            }
    
            const productElementOffer = document.createElement('div');
            productElementOffer.classList.add('xproduct');
            productElementOffer.innerHTML = `
              <img src="${imageSrc}" width="50">
              <div class="xremove">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.39317 0.666748L3.99984 3.06008L1.6065 0.666748L0.666504 1.60675L3.05984 4.00008L0.666504 6.39341L1.6065 7.33341L3.99984 4.94008L6.39317 7.33341L7.33317 6.39341L4.93984 4.00008L7.33317 1.60675L6.39317 0.666748Z" fill="white"/>
                </svg>
              </div>`;
    
            document.querySelector('.selected-product').appendChild(productElementOffer);
            document.querySelector('.selected-product').classList.add('selected-product' + selectedCount);
    
            item.style.display = 'none';
            selectedCount++;
    
            if (selectedCount === xcart_item_count) {
              document.querySelectorAll('.additem').forEach(btn => {
                if (btn.closest('.xitems').style.display !== 'none') {
                  btn.classList.add('disabled');
                  btn.closest('.xitems').style.display = 'none';
                  document.querySelector('.xbtn.more').style.display = 'none';
                }
              });
            }
    
            productElementOffer.querySelector('.xremove').addEventListener('click', function() {
              const productElement = this.closest('.xproduct');
              productElement.remove();
              selectedCount--;
              if (selectedCount == 0 && xcart_item_count_progress == 1) {
                updateProgressBar(33.33);
              } else if (selectedCount == 1 && xcart_item_count_progress == 1) {
                updateProgressBar(66.66);
              } else if (selectedCount == 1 && xcart_item_count_progress == 2) {
                updateProgressBar(66.66);
              } else if (selectedCount == 0 && xcart_item_count_progress == 2) {
                updateProgressBar(66.66);
              }
    
              document.querySelector('.selected-product').classList.remove('selected-product' + selectedCount);
              if (productElement) {
                selectedItems.splice(selectedItems.findIndex(item => item.productName === productName && item.variant === variant), 1);
                item.style.display = 'flex';
                if (selectedCount < xcart_item_count) {
                  document.querySelectorAll('.additem.disabled').forEach(btn => {
                    btn.classList.remove('disabled');
                    btn.closest('.xitems').style.display = 'flex';
                    document.querySelector('.xbtn.more').style.display = 'block';
                  });
                }
              }
            });
          }
        });
      });
  
      document.querySelector('.additemtocart').addEventListener('click', function() {
        addToCart(selectedItems);
        const addToCartButton = this;
        addToCartButton.textContent = 'Adding...';
        addToCartButton.disabled = true;
      });
  
      
  
      function addToCart(items) {
        if (items.length === 0) {
          console.log('No items selected.');
          return;
        }
    
        let formData = new FormData();
        formData = {
          items: items.map(item => ({
            id: item.variant,
            quantity: item.quantity,
            properties: {
              "_apply_discount": item.applyDiscount,
              _cart_calculation: item.subscribeDiscountPct
              
            }
          }))
        };
    
        let addToCartButton = document.querySelector('.additemtocart');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(data => {
            addToCartButton.textContent = 'Added to Cart';
            selectedItems.length = 0;
            selectedCount = 0;
            document.querySelector('.selected-product').innerHTML = '';
            document.body.classList.remove('xt-cart-recommended-active');
  
  
          })
          .catch((error) => {
            console.error('Error:', error);
            addToCartButton.textContent = 'Parameter missing';
          })
          .finally(() => {
              
                const isCartDrawer = document.querySelector('cart-drawer-items') !== null; // Check if in cart drawer
              const sectionId = isCartDrawer ? 'cart-drawer' : 'main-cart-items';
              const fetchUrl = `${window.Shopify.routes.root}cart?section_id=${sectionId}`;
            
              fetch(fetchUrl)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const selectors = isCartDrawer
                    ? ['cart-drawer-items', '.cart-drawer__footer']
                    : ['cart-items', '.js-contents'];
            
                  selectors.forEach((selector) => {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                      targetElement.replaceWith(sourceElement);
                    }
                  });
                })
                .catch((e) => {
                  console.error('Error refreshing cart:', e);
                });
             
          });
      }
    
      document.querySelector('.xt-another-box').addEventListener('click', function() {
        document.querySelector('.xt-cart-recommended').classList.add('xactive');
        document.body.classList.add('xt-cart-recommended-active');
        let xcart_item_count = document.querySelector('.xcart_item_count').value;
        if (xcart_item_count == 2) {
          updateProgressBar(66.66);
        }
      });
    
      document.querySelector('.xheader').addEventListener('click', function() {
        document.querySelector('.xt-cart-recommended').classList.remove('xactive');
        document.body.classList.remove('xt-cart-recommended-active');
      });
    }
  }

  // Method to update the free shipping progress
  // updateFreeShippingProgress(cartTotal, hasSellingPlan) 
  // {
  //   const freeShippingThresholdElement = document.getElementById('freeshiipingthreshold'); // Free shipping threshold
  //   const freeShippingThreshold = freeShippingThresholdElement ? freeShippingThresholdElement.value : null;
  //   const progressBarContainer = document.querySelector('.xt-progress-bar'); // Progress bar container
  //   console.log(freeShippingThreshold); // Logs the value of the hidden input, or null if not found
  //   const progressBar = document.getElementById('file'); // Progress bar element
  //   const label = document.getElementById('remainingprice'); // Label for remaining amount text

  //   if (!progressBar || !label) {
  //     console.error('Progress bar or label element is missing.');
  //     return;
  //   }

  //    // If any item has a selling plan, show free shipping achieved
  //   if (hasSellingPlan) {
  //     progressBar.value = 100; // Set progress to 100%
  //     label.textContent = `Congratulations! You qualify for Free Shipping.`;
  //     progressBarContainer.classList.add("freeshippingachieved");
  //     return;
  //   }

  //   // Calculate the progress percentage
  //   const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

  //   // Update the progress bar value
  //   progressBar.value = progress;

  //   // Update the label text
  //   if (cartTotal >= freeShippingThreshold) {
  //     progressBarContainer.classList.add("freeshippingachieved");
  //   } else {
  //     const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
  //     console.log(remaining);
  //     label.textContent = `$${remaining}`;
  //     progressBarContainer.classList.remove("freeshippingachieved");
  //   }
  // }

  

  // // Method to fetch cart total and update the progress bar
  // fetchCartTotalAndUpdateProgress() {
  //   fetch('/cart.js') // Shopify cart endpoint
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       const cartTotal = cart.total_price / 100; // Shopify total_price is in cents
  //       const hasSellingPlan = cart.items.some((item) => item.selling_plan_allocation); // Check for selling plans
  //       this.updateFreeShippingProgress(cartTotal, hasSellingPlan);
  //     })
  //     .catch((error) => {
  //       console.error('Failed to fetch cart total:', error);
  //     });
  // }

  // Handle selling plan change event
  handleSellingPlanChange(event) {

    console.log(event);
    const lineItemIndex = event.target.dataset.index;
    console.log(lineItemIndex);
    const newSellingPlanId = event.target.value;
    const lineItem = this.querySelector(`#CartDrawer-Item-${lineItemIndex}, #CartItem-${lineItemIndex}`);
    console.log(lineItem);
    const quantityInput = lineItem.querySelector('input[data-quantity-variant-id]');
    const quantityValue = quantityInput.value; 
    
    const variantId = quantityInput.getAttribute('data-quantity-variant-id');
    const SellingPlan = this.getUpdatedSellingPlan(newSellingPlanId);
    this.updateSellingPlan(lineItemIndex, quantityValue, lineItem.querySelector('input[name="updates[]"]').name, variantId, SellingPlan);
  }

  getUpdatedSellingPlan(sellingPlanId) {
    return {
      sellingPlanId,
    };
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
     const index = event.target.dataset.index;
      let message = '';
  
      if (inputValue < event.target.dataset.min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
      } else if (inputValue > parseInt(event.target.max)) {
        message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
      } else if (inputValue % parseInt(event.target.step) !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
      }
  
      if (message) {
        // this.setValidity(event, index, message);
      } else {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(
          index,
          inputValue,
          // document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      }
  }

  onChange(event) {

    console.log(event);
    this.validateQuantity(event);
    // this.fetchCartTotalAndUpdateProgress();
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contentssecond',
      },
    ];
  }

   updateSellingPlan(line, quantity, name, variantId, SellingPlan) {
    this.enableLoading(line);

    // Ensure SellingPlan is defined and contains a sellingPlanId
    const sellingPlanID = SellingPlan && SellingPlan.sellingPlanId ? SellingPlan.sellingPlanId : null;
    console.log(sellingPlanID);
     console.log(this.getSectionsToRender().map((section) => section.section));
     console.log(window.location.pathname);
    // Prepare the body for the request, passing the updated selling plan
    const body = JSON.stringify({
      line,
      quantity,
      selling_plan: sellingPlanID,  // Pass the updated selling plan here
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    // Perform the fetch request to update the cart
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        // Handle errors from the cart update
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Toggle visibility for empty cart
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        // Update the relevant sections in the DOM
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        // Check if the quantity in the cart matches the updated value
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        // Publish the updated cart state
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
      })
      .catch(() => {
        // Handle any errors during the fetch request
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // Disable loading state after the request
        this.disableLoading(line);
      });
  }
  
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        //this is for check free gift item
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartTotal = cart.total_price;
          const cart_item_count = cart.item_count;
          let freeprop = '_free_gift_product';
          let freekey = '';
          
          // Check if the gift is already in the cart
          const giftInCart = cart.items.filter(function(item) {
            return (item.properties!= null && item.properties['_free_gift_product']=='true');
          });
          
          if(giftInCart.length>0)
          {
            freekey = giftInCart[0].id;
          }
          //rama update here  
          if (freekey!='' && cart_item_count == 1 && cartTotal==0) {
            let line = 1;
            let quantity = 0;
            this.enableLoading(line);
            const body = JSON.stringify({
                line,
                quantity,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname,
              });
          
              fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => {
                  return response.text();
                })
                .then((state) => {
                const parsedState = JSON.parse(state);
                const quantityElement =
                  document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll('.cart-item');
        
                if (parsedState.errors) {
                  quantityElement.value = quantityElement.getAttribute('value');
                  this.updateLiveRegions(line, parsedState.errors);
                  return;
                }
        
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');
        
                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        
                this.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                  );
                });
                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                let message = '';
                if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                  if (typeof updatedValue === 'undefined') {
                    message = window.cartStrings.error;
                  } else {
                    message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                  }
                }
                this.updateLiveRegions(line, message);
        
                const lineItem =
                  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                  cartDrawerWrapper
                    ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                    : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                }
        
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
            })
            .catch(() => {
              this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
              const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
              errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
              this.disableLoading(line);
            });
          }//if closed
          else
          {
            const parsedState = JSON.parse(state);
            const quantityElement =
              document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            const items = document.querySelectorAll('.cart-item');
    
            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute('value');
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }
    
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');
    
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            let message = '';
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
            this.updateLiveRegions(line, message);
    
            const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }
    
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
            
          }//else closed
          
        })
        .catch(error => {
         console.error('Error fetching cart:', error);
        });
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
